module.exports = {
  media: {
    badge: "Test",
    title: "Example",
    subtitle: "Test example",
    summaryTitle: "Test",
    summaryText: "Example",
    summaryPoints: ["Test", "Example", "Test"],
    cardsTitle: "Test",
    cardsSubtitle: "Example",
    cards: [
      { icon: "fas fa-photo-film", title: "Test", text: "Example" },
      { icon: "fas fa-file-powerpoint", title: "Example", text: "Test" },
      { icon: "fas fa-folder-open", title: "Test", text: "Example" }
    ],
    listTitle: "Test",
    listSubtitle: "Example",
    listItems: ["Test", "Example", "Test"],
    stats: [
      { value: "Test", label: "Example" },
      { value: "Example", label: "Test" }
    ],
    ctaTitle: "Test",
    ctaText: "Example",
    primaryHref: "/pages/contact",
    primaryLabel: "Test",
    secondaryHref: "/pages/services",
    secondaryLabel: "Example",
    filterAriaLabel: "Test",
    modalCloseLabel: "Test",
    modalTitle: "Example",
    modalDescription: "Test",
    filters: [
      { key: "all", label: "Test", icon: "fas fa-th" },
      { key: "photo", label: "Example", icon: "fas fa-image" },
      { key: "video", label: "Test", icon: "fas fa-video" }
    ],
    items: [
      { type: "video", icon: "fas fa-play-circle", placeholder: "Test", title: "Example", description: "Test", badge: "Example", badgeIcon: "fas fa-video", playLabel: "Test" },
      { type: "photo", icon: "fas fa-image", placeholder: "Example", title: "Test", description: "Example", badge: "Test", badgeIcon: "fas fa-image" },
      { type: "video", icon: "fas fa-play-circle", placeholder: "Test", title: "Example", description: "Test", badge: "Example", badgeIcon: "fas fa-video", playLabel: "Test" },
      { type: "photo", icon: "fas fa-image", placeholder: "Example", title: "Test", description: "Example", badge: "Test", badgeIcon: "fas fa-image" },
      { type: "photo", icon: "fas fa-image", placeholder: "Test", title: "Example", description: "Test", badge: "Example", badgeIcon: "fas fa-image" },
      { type: "video", icon: "fas fa-play-circle", placeholder: "Example", title: "Test", description: "Example", badge: "Test", badgeIcon: "fas fa-video", playLabel: "Test" }
    ]
  }
};